export { useAppForm, withForm } from '~/common/form/formHook';

export { useStore } from '@tanstack/react-form';

export const AUS_FORM_MESSAGES = {
  agencyRequired: 'Agency is required',
  userNameRequired: 'User Name is required',
  passwordRequired: 'Password is required',
  freOfferingRequired: 'FRE Offering ID is required',
  creditRefRequired: 'Credit Reference is required',
  lpaBranchLength: 'Must be exactly 4 characters',
};

export interface AUSFormData {
  userName: string;
  password: string;
  agency: string;
  freOfferingId: string;
  lpaBranchNumber: string;
  positiveRentalPaymentHistory: boolean;
  [key: string]: AUSFieldValue;
}

export type AUSFieldValue = string | boolean;
